import { apiSlice } from "../../../../api/apiSlice";
import * as constants from '../../../../constants';

export const agentFilterSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        GetParentClientsByConfig: builder.query({
            query: (arg: any) => {
                const {
                    clientId,
                    programId,
                    projectId,
                    countryId,
                    geolocationId,
                    configCode
                } = arg;
                return {
                    url: constants.PARENT_CLIENT_BY_CONFIG,
                    params: {
                        clientId,
                        programId,
                        projectId,
                        countryId,
                        geolocationId,
                        configCode
                    },
                };
            },
        }),
        getClientsByConfig: builder.query({
            query: (arg: any) => {
                const {
                    parentClientId,
                    programId,
                    projectId,
                    countryId,
                    geolocationId,
                    configCode

                } = arg;
                return {
                    url: constants.CLIENT_BY_CONFIG,
                    params: {
                        parentClientId,
                        programId,
                        projectId,
                        countryId,
                        geolocationId,
                        configCode
                    },
                };
            },
        }),
        getProgramsByConfig: builder.query({
            query: (arg: any) => {
                const {
                    parentClientId,
                    clientId,
                    projectId,
                    countryId,
                    geolocationId,
                    configCode
                } = arg;
                return {
                    url: constants.PROGRAM_BY_CONFIG,
                    params: {
                        parentClientId,
                        clientId,
                        projectId,
                        countryId,
                        geolocationId,
                        configCode
                    },
                };
            },
        }),
        getProjectsByConfig: builder.query({
            query: (arg: any) => {
                const {
                    parentClientId,
                    clientId,
                    programId,
                    countryId,
                    geolocationId,
                    configCode
                } = arg;
                return {
                    url: constants.PROJECT_BY_CONFIG,
                    params: {
                        parentClientId,
                        clientId,
                        programId,
                        countryId,
                        geolocationId,
                        configCode
                    },
                };
            },
        }),
        getCountriesByConfig: builder.query({
            query: (arg: any) => {
                const {
                    parentClientId,
                    clientId,
                    programId,
                    projectId,
                    geolocationId,
                    configCode
                } = arg;
                return {
                    url: constants.COUNTRY_BY_CONFIG,
                    params: {
                        parentClientId,
                        clientId,
                        programId,
                        projectId,
                        geolocationId,
                        configCode
                    },
                };
            },
        }),
        getGlLocationsByConfig: builder.query({
            query: (arg: any) => {
                const { parentClientId, clientId, programId,projectId, countryId,configCode } =
                    arg;
                return {
                    url: constants.GLLOCATIONS_BY_CONFIG,
                    params: {
                        parentClientId,
                        clientId,
                        programId,
                        countryId,
                        projectId,
                        configCode
                    },
                };
            },
        }),
        getAgentsSearch: builder.query({
            query: (arg: any) => {
                const { parentClientId,clientId,programId,projectId,countryId,geolocationId } = arg;
                return {
                    url: constants.AGENTS_SEARCH,
                    params: {  parentClientId,clientId,programId,projectId,countryId,geolocationId },
                };
            },
        }),
    }),
});

export const {
    useGetParentClientsByConfigQuery,
    useGetClientsByConfigQuery,
    useGetProgramsByConfigQuery,
    useGetProjectsByConfigQuery,
    useGetCountriesByConfigQuery,
    useGetGlLocationsByConfigQuery,
    useGetAgentsSearchQuery,
} = agentFilterSlice;
